var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cpre\u003E{{$ctrl.record.diagnostic.uri[0]}} {{$ctrl.record.diagnostic.message[0]}}\u003C\u002Fpre\u003E";;return pug_html;};
module.exports = template;